module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "score-login-extra"
  }, [_c('van-cell-group', {
    staticClass: "score-cell"
  }, [_c('van-field', {
    attrs: {
      "name": "身份证号",
      "left-icon": require('../../../assets/images/score/login-card.png'),
      "clearable": "",
      "readonly": _vm.readonly,
      "placeholder": "请输入身份证号",
      "rules": [{
        required: true,
        message: '身份证号'
      }]
    },
    on: {
      "focus": _vm.onFocus
    },
    model: {
      value: (_vm.formData.id_code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_code", $$v)
      },
      expression: "formData.id_code"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.id_code == 'X001'),
      expression: "formData.id_code == 'X001'"
    }],
    staticClass: "fr flex-start"
  }, [_c('div', {
    staticClass: "mr10"
  }, [_vm._v("云上版")]), _vm._v(" "), _c('van-switch', {
    attrs: {
      "inactive-color": "#eee",
      "size": "24px"
    },
    on: {
      "change": _vm.switchChange
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml10"
  }, [_vm._v("内网版")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "score-content-right flex-start"
  }, [_c('div', {
    staticClass: "key-left"
  }, [_c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(1)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(2)
      }
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(3)
      }
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(4)
      }
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(5)
      }
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(6)
      }
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(7)
      }
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(8)
      }
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(9)
      }
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('div', {
    staticClass: "key-li-full",
    on: {
      "click": function($event) {
        return _vm.onKey(0)
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey('X')
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "key-right"
  }, [_c('div', {
    staticClass: "key-delete flex-center",
    on: {
      "click": function($event) {
        return _vm.onKey('delete')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/score-delete.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.saveLoading) ? _c('div', {
    staticClass: "key-button flex-center",
    staticStyle: {
      "background": "#44D7B6",
      "color": "#fff"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("登录\n          ")]) : _c('div', {
    staticClass: "key-button flex-center",
    staticStyle: {
      "background": "#44D7B6",
      "color": "#fff",
      "cursor": "not-allowed"
    }
  }, [_vm._v("登录中...\n          ")])])])], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "title": "正在进行"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('van-cell-group', _vm._l((_vm.list), function(item, index) {
    return _c('van-cell', {
      attrs: {
        "title": item.saiqu_name + ' ' + item.title,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.toScoreCheck(item.id)
        }
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-login-box"
  }, [_c('div', {
    staticClass: "score-login-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/logo2.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-265eb35e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/CommonLogin2.vue
// module id = 2278
// module chunks = 0